import { Campaign, CampaignCreateParams, Provider, Subscription } from '../../../types'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import TextInput from '../../../ui/form/TextInput'
import Heading from '../../../ui/Heading'
import CampaignChannelTiles from './CampaignChannelTiles'
import CampaignTypeTiles from './CampaignTypeTiles'

interface GeneralStepProps {
    form: UseFormReturn<CampaignCreateParams>
    campaign?: Campaign
    showType: boolean
    subscriptions: Subscription[]
    providers: Provider[]
}

export default function CampaignGeneralStep({ form, campaign, showType, subscriptions, providers }: GeneralStepProps) {
    const { t } = useTranslation()
    return (
        <>
            <Heading size="h3" title={t('wizard_basics_title')}>
                {t('wizard_basics_desc')}
            </Heading>
            <TextInput.Field form={form}
                name="name"
                label={t('campaign_name')}
                required
            />

            {showType && <CampaignTypeTiles form={form} />}

            {campaign
                ? (
                    <Heading size="h4" title={t('channel')}>
                        {t('wizard_channel_locked', { channel: campaign.channel })}
                    </Heading>
                )
                : (
                    <CampaignChannelTiles
                        subscriptions={subscriptions}
                        providers={providers}
                        form={form}
                    />
                )
            }
        </>
    )
}
